<template>
  <div style="flex: 1; padding: 20px">
    <el-row>
      <h2 style="float: left; margin-left: 15px">Device</h2>
      <br />
    </el-row>
    <br />
    <el-card>
      <el-row>
        <el-form
          :inline="true"
          :model="query"
          :label-position="'top'"
          class="demo-form-inline"
        >
          <el-col>
            <el-form-item label="Type">
              <el-select
                @change="load"
                clearable
                filterable
                autocomplete
                multiple
                allow-create
                default-first-option
                value-key="item"
                v-model="query.type"
                placeholder="Select"
              >
                <el-option
                  v-for="deviceType in deviceTypes"
                  :key="deviceType.type"
                  :label="deviceType.type"
                  :value="deviceType.type"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="macAddress">
              <the-mask
                class="el-input__inner"
                v-model="query.macAddress"
                :masked="true"
                mask="FF:FF:FF:FF:FF:FF"
                @input="sanitize($event)"
                @keyup.enter.native="load"
                :tokens="hexTokens"
              />
            </el-form-item>
            <el-form-item label="Partner" prop="partner">
              <el-select
                @change="loadCustomers"
                v-model="query.partner"
                placeholder="Select"
                filterable
                clearable
              >
                <el-option
                  v-for="item in partnerSelect"
                  :key="item.value"
                  :label="item.label"
                  :value="item.key"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="Customer" prop="customer">
              <el-select
                @change="load"
                v-model="query.customer"
                filterable
                placeholder="Select"
                clearable
              >
                <el-option
                  v-for="item in customerSelect"
                  :key="item.value"
                  :label="item.label"
                  :value="item.key"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="Version">
              <el-row style="width: 200px">
                <el-col :span="20">
                  <el-input
                    @keyup.enter.native="load"
                    placeholder="Please input"
                    v-model="query.version"
                  ></el-input>
                </el-col>
                <el-col :span="4">
                  <el-button
                    style="margin-left: 5px"
                    :icon="sortIcon"
                    type="primary"
                    size="mini"
                    circle
                    @click="sortTypeChange()"
                  >
                  </el-button>
                </el-col>
              </el-row>
            </el-form-item>
            <el-form-item label="Connection">
              <el-select
                style="width: 170px"
                @change="load"
                v-model="query.connectionStatus"
                placeholder="Select"
                clearable
              >
                <el-option
                  v-for="item in connectionStatusSelect"
                  :key="item.value"
                  :label="item.label"
                  :value="item.key"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="Note">
              <el-input
                @keyup.enter.native="load"
                placeholder="Please input"
                v-model="query.note"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-form>
        <el-col>
          <el-button
            type="primary"
            @click="
              query.page = 1;
              load();
            "
            >Filter</el-button
          >
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24" style="text-align: right">
          <el-pagination
            layout="prev, pager, next,sizes"
            :total="searchResult.total"
            :page-sizes="pageSizes"
            :page-size.sync="query.pageSize"
            :current-page.sync="query.page"
            @current-change="load"
            @size-change="load"
          ></el-pagination>
          <!-- Table -->
        </el-col>
        <el-col>
          <el-table
            v-loading="loading"
            :data="searchResult.devices"
            class="border"
          >
            <el-table-column type="index" width="50" />
            <el-table-column
              prop="type"
              label="Type"
              sortable
              column-key="type"
            />
            <el-table-column prop="availableGateways" label="availableGateways">
              <template slot-scope="scope">
                <el-popover placement="left-end" width="500" trigger="hover">
                  <p style="white-space: pre-wrap">
                    {{ avaliableGatewaysList(scope.row.availableGateways) }}
                  </p>
                  <i
                    class="color-circle"
                    v-bind:style="{
                      'background-color': statusColor(
                        scope.row.availableGateways
                      ),
                    }"
                    slot="reference"
                  ></i>
                </el-popover>
              </template>
            </el-table-column>
            <el-table-column sortable prop="macAddress" label="macAddress" />
            <el-table-column prop="customer" label="Customer">
            </el-table-column>
            <el-table-column prop="partner" label="Partner"> </el-table-column>
            <el-table-column sortable prop="version" label="Version">
              <template slot-scope="scope">
                <el-row>
                  <el-col v-if="!editShowLine" :span="12">
                    <span>
                      {{ scope.row.version }}
                    </span>
                  </el-col>
                  <el-col
                    :span="12"
                    v-show="
                      editShowLine && form.macAddress == scope.row.macAddress
                    "
                  >
                    <el-select
                      clearable
                      v-model="form.firmware"
                      placeholder="Select"
                      size="mini"
                    >
                      <el-option
                        v-for="item in firmwares"
                        :key="item.key"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </el-col>
                  <el-col
                    :span="6"
                    v-show="
                      editShowLine && form.macAddress == scope.row.macAddress
                    "
                  >
                    <el-button
                      style="margin-left: 5px"
                      icon="el-icon-upload"
                      type="primary"
                      size="mini"
                      circle
                      @click="firmwareUpdate(form)"
                    ></el-button>
                  </el-col>
                  <el-col
                    v-show="
                      otaInPorgress && form.macAddress == scope.row.macAddress
                    "
                    :span="6"
                  >
                    <el-progress
                      :width="40"
                      type="circle"
                      :percentage="otaProgress"
                    ></el-progress>
                  </el-col>
                  <el-col
                    :span="6"
                    v-show="!!scope.row.availableGateways.length"
                  >
                    <el-button
                      style="float: right"
                      type="primary"
                      icon="el-icon-edit"
                      size="mini"
                      @click="EditVerison(scope)"
                      circle
                      :loading="
                        editVersionLoading &&
                        form.macAddress == scope.row.macAddress
                      "
                    ></el-button>
                  </el-col>
                </el-row>
              </template>
            </el-table-column>
            <el-table-column
              sortable
              prop="versionRequestedAt"
              label="VersionRequestedAt"
            />
            <el-table-column label="Actions" width="350px">
              <template slot-scope="scope">
                <el-popover
                  placement="bottom"
                  style="margin-left: 10px"
                  width="200"
                  trigger="click"
                >
                  <el-row>
                    <el-col>
                      <el-input
                        type="textarea"
                        placeholder="take note"
                        :maxlength="250"
                        :show-word-limit="true"
                        v-model="scope.row.note"
                        size="small"
                      />
                    </el-col>
                    <el-col>
                      <el-button
                        style="margin-top: 10px; float: right"
                        size="mini"
                        @click="UpdateDevice(scope.row)"
                      >
                        Save</el-button
                      >
                    </el-col>
                  </el-row>
                  <el-button
                    icon="el-icon-notebook-2"
                    slot="reference"
                    size="mini"
                  ></el-button>
                </el-popover>
              </template>
            </el-table-column>
          </el-table>
        </el-col>

        <el-col :span="24" style="text-align: right">
          <el-pagination
            layout="prev, pager, next,sizes"
            :total="searchResult.total"
            :page-sizes="pageSizes"
            :page-size.sync="query.pageSize"
            :current-page.sync="query.page"
            @current-change="load"
            @size-change="load"
          ></el-pagination>
          <!-- Table -->
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>



<script>
import { mapState, mapActions } from "vuex";
import { TheMask } from "vue-the-mask";
import dayjs from "dayjs";
import iot from "../service/iot";
import mqtt from "mqtt";

export default {
  name: "Device",
  components: { TheMask },
  data() {
    let IsMacAddress = (rule, value, callback) => {
      if (
        !/^[0-9A-F]{2}:[0-9A-F]{2}:[0-9A-F]{2}:[0-9A-F]{2}:[0-9A-F]{2}:[0-9A-F]{2}$/g.test(
          value
        )
      ) {
        return callback(
          new Error("Please input proper mac address (ex: AB:CD:EF:12:34:56)")
        );
      }
      return callback();
    };
    return {
      hexTokens: {
        F: {
          pattern: /[0-9a-fA-F]/,
          transform: (v) => v.toLocaleUpperCase(),
        },
      },
      otaInPorgress: false,
      otaProgress: 0,
      sortIcon: "el-icon-d-caret",
      query: {
        connectionStatus: "",
        macAddress: "",
        customer: "",
        partner: "",
        type: "",
        version: "",
        page: 1,
        pageSize: 10,
        note: "",
        sortType: "",
        sortDirection: -1,
      },
      editVersionLoading: false,
      editShowLine: false,
      pageSizes: [10, 25, 50, 75],
      versionUpdated: false,
      updatePercentage: 0,
      updateVersionStatus: "warning",
      types: [
        {
          value: "ANCHOR",
          label: "Anchor",
        },
        {
          value: "INFINITY",
          label: "Infinity",
          disabled: true,
        },
        {
          value: "WIRED",
          label: "Wired",
        },
        {
          value: "THIRD-PARTY",
          label: "Third-party",
        },
      ],
      connectionStatusSelect: [
        {
          value: "all",
          label: `all`,
          key: "all",
        },
        {
          value: "connected",
          label: `connected`,
          key: "connected",
        },
        {
          value: "disconnected",
          label: `disconnected`,
        },
      ],
      editId: "",
      showForm: false,
      editShowform: false,
      formLoading: false,
      form: {
        customer: "",
        macAddress: "",
        type: "",
      },
      rules: {
        name: [
          { required: true, message: "Please input name", trigger: "blur" },
        ],
        macAddress: [
          {
            validator: IsMacAddress,
            trigger: "blur",
          },
        ],
      },
    };
  },
  created() {
    this.getDevices(this.query);
    this.getDeviceTypes();
    this.getCustomers();
    this.getPartners();
  },
  computed: {
    ...mapState("device", [
      "searchResult",
      "loading",
      "deviceTypes",
      "firmwares",
    ]),
    ...mapState("partner", ["customers", "partners"]),
    customerSelect() {
      return this.customers.map((x) => {
        return {
          value: x._id,
          label: `${x.name}(${x._id})`,
          key: x._id,
        };
      });
    },
    partnerSelect() {
      return this.partners.map((x) => {
        return {
          value: x._id,
          label: `${x.name}(${x._id})`,
          key: x._id,
        };
      });
    },
  },
  methods: {
    async loadCustomers() {
      this.query.customer = "";
      await this.getCustomers({ partner: this.query.partner });
      await this.load();
    },
    ...mapActions("device", [
      "getDeviceTypes",
      "getDevices",
      "createDevice",
      "updateDevice",
      "deleteDevice",
      "getDeviceFirmwares",
      "updateDeviceFirmwares",
      "getDeviceVersion",
    ]),
    ...mapActions("partner", ["getPartners", "getCustomers"]),
    sortTypeChange() {
      switch (this.sortIcon) {
        case "el-icon-d-caret":
          this.sortIcon = "el-icon-caret-bottom";
          this.query.sortType = "version";
          this.query.sortDirection = -1;
          break;
        case "el-icon-caret-bottom":
          this.sortIcon = "el-icon-caret-top";
          this.query.sortType = "version";
          this.query.sortDirection = 1;
          break;
        case "el-icon-caret-top":
          this.sortIcon = "el-icon-d-caret";
          this.query.sortType = "";
          this.query.sortDirection = -1;
          break;
        default:
          this.sortIcon = "el-icon-d-caret";
          this.query.sortType = "";
          this.query.sortDirection = -1;
          break;
      }
    },
    UpdateDevice(scope) {
      this.updateDevice({
        _id: scope._id,
        note: scope.note,
      })
        .then(() => {
          this.showForm = false;
          this.load();
        })
        .finally(() => {
          this.editId = "";
          this.form = {
            macAddress: "",
            customer: "",
            type: "",
            note: "",
          };
        });
    },
    CreateDevice() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.formLoading = true;
          this.createDevice({
            customer: this.form.customer,
            macAddress: this.form.macAddress,
            type: this.form.type,
          })
            .then(() => {
              this.formLoading = false;
              this.showForm = false;
            })
            .finally(() => (this.formLoading = false));
        }
      });
    },

    EditVerison(scope) {
      this.editShowLine = !this.editShowLine;
      if (this.editShowLine) {
        this.form = {
          _id: scope.row._id,
          macAddress: scope.row.macAddress,
        };
        this.editVersionLoading = true;
        this.getDeviceFirmwares(this.form).then(() => {
          this.editVersionLoading = false;
          this.editShowLine = true;
        });
      }
    },

    initiateMqtt() {
      return new Promise((res, rej) => {
        this.disconnect();
        iot
          .getSigv4Url()
          .then((x) => {
            this.connecting = true;
            var self = this;
            if (self.mqttClient) {
              self.mqttClient.end(true);
            }
            self.mqttClient = mqtt.connect(x.url, {
              protocol: "wss",
              clientId: self.$uuid.v1(),
            });

            self.mqttClient.on("connect", () => {});
            self.mqttClient.once("error", (e) => {
              self.$mesasge.info("error occured", e);
            });
            self.mqttClient.on("error", () => {
              self.$message.error("Someting went wrong");
            });
            self.mqttClient.on("reconnect", () => {});
            self.mqttClient.on("close", () => {});
            self.mqttClient.on("disconnect", () => {});
            self.mqttClient.on("offline", () => {});
            self.mqttClient.on("message", self.onMessage);
            self.mqttClient.subscribe(
              [
                `prod/gateway/+/device/${this.form.macAddress}/ota/accepted`,
                `prod/gateway/+/device/${this.form.macAddress}/ota/rejected`,
                `prod/gateway/+/device/${this.form.macAddress}/ota/done`,
                `prod/gateway/+/device/${this.form.macAddress}/version/accepted`,
                `prod/gateway/+/device/${this.form.macAddress}/version/rejected`,
              ],
              (err) => {
                if (!err) {
                  res("ok");
                } else {
                  console.log(err);
                  rej(err);
                }
              }
            );
          })
          .catch((e) => {
            console.log(e);
            this.connecting = false;
          });
      });
    },
    onMessage(topic, payload) {
      let messageString = payload.toString();
      let topicTokens = topic.split("/");
      if (
        topicTokens[topicTokens.length - 1] === "rejected" &&
        topicTokens[topicTokens.length - 2] === "ota"
      ) {
        this.otaProgress = 0;
        this.otaInPorgress = false;
        this.$message.error(
          `${
            topicTokens[topicTokens.length - 3]
          } rejected OTA. ${messageString}`
        );
        this.editShowLine = false;
        this.editVersionLoading = false;
        this.versionUpdated = true;
        this.disconnect();
      } else if (
        topicTokens[topicTokens.length - 1] === "accepted" &&
        topicTokens[topicTokens.length - 2] === "ota"
      ) {
        this.otaProgress = 30;
        this.otaInPorgress = true;
        this.$message.success(
          `${topicTokens[topicTokens.length - 3]} accepted OTA`
        );
      } else if (
        topicTokens[topicTokens.length - 1] === "done" &&
        topicTokens[topicTokens.length - 2] === "ota"
      ) {
        this.otaProgress = 100;
        setTimeout(() => {
          this.otaInPorgress = false;
        }, 500);
        this.$message.success(
          `${topicTokens[topicTokens.length - 3]} done OTA`
        );
        this.versionUpdated = true;
        this.editShowLine = false;
        this.editVersionLoading = false;
        this.disconnect();
      } else if (
        topicTokens[topicTokens.length - 1] === "accepted" &&
        topicTokens[topicTokens.length - 2] === "version"
      ) {
        let newVersion = this.form.firmware
          .slice(
            this.form.firmware.indexOf("version") + 8,
            this.form.firmware.indexOf(".")
          )
          .replaceAll("-", ".");
        if (newVersion == messageString) {
          this.otaProgress = 100;
          setTimeout(() => {
            this.otaInPorgress = false;
          }, 500);
          this.$message.success(
            `${topicTokens[topicTokens.length - 3]} done OTA`
          );
        } else {
          this.otaProgress = 0;
          this.otaInPorgress = false;
          this.$message.error(
            `${topicTokens[topicTokens.length - 3]} error during OTA`
          );
        }
        this.versionUpdated = true;
        this.editShowLine = false;
        this.editVersionLoading = false;
        this.disconnect();
      } else if (
        topicTokens[topicTokens.length - 1] === "rejected" &&
        topicTokens[topicTokens.length - 2] === "version"
      ) {
        this.$message.error(
          `${
            topicTokens[topicTokens.length - 3]
          } rejected version. OTA may not done`
        );
        this.otaProgress = 0;
        this.otaInPorgress = false;
        this.versionUpdated = true;
        this.editShowLine = false;
        this.editVersionLoading = false;
        this.disconnect();
      }
    },
    updatedVersionLoop(data) {
      setTimeout(() => {
        if (
          !this.versionUpdated &&
          typeof data.gateway == "string" &&
          typeof data.device == "string"
        ) {
          this.getDeviceVersion({
            device: data.device,
            gateway: data.gateway,
            type: this.form.type,
          });
        }
      }, 60000);
      setTimeout(() => {
        if (!this.versionUpdated) {
          this.$message.error(`${this.form.macAddress} TIME_OUT`);
          this.otaProgress = 0;
          this.otaInPorgress = false;
          this.versionUpdated = true;
          this.editShowLine = false;
          this.editVersionLoading = false;
          this.disconnect();
        }
      }, 90000);
    },
    disconnect() {
      this.connecting = false;
      this.connected = false;
      if (this.mqttClient) {
        this.mqttClient.end(true);
      }
    },
    async firmwareUpdate(form) {
      if (form.firmware) {
        this.editShowLine = false;
        this.editVersionLoading = true;
        await this.initiateMqtt();
        this.otaProgress = 10;
        this.otaInPorgress = true;
        this.updateDeviceFirmwares(this.form).then((data) => {
          if (data == undefined) {
            this.otaProgress = 0;
            setTimeout(() => {
              this.otaInPorgress = false;
            }, 500);
            this.versionUpdated = true;
            this.editShowLine = false;
            this.editVersionLoading = false;
            this.disconnect();
          } else {
            this.updatedVersionLoop(data);
          }
        });
        this.showForm = false;
        this.editShowform = false;
      } else {
        this.$message.error("Please select firmware version");
      }
    },
    avaliableGatewaysList(avaliableGatewaysList) {
      return avaliableGatewaysList
        .map(
          (x) =>
            x._id.gateway +
            " - " +
            dayjs(x.createdAt).format("DD-MM-YYYY HH:mm:ss")
        )
        .join("\n");
    },
    statusColor(gateways) {
      if (!gateways.length) {
        return "#808080";
      } else {
        return "#00FF00";
      }
    },
    dayFormat(createdAt) {
      return dayjs(createdAt).format("DD-MM-YYYY HH:mm:ss");
    },
    load() {
      this.getDevices(this.query);
    },
    sanitize(value) {
      this.form.macAddress = value.trim().toUpperCase();
    },
    adviseSystemAdmin() {
      this.$message.info("advise to the system admin");
    },
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>
<style scoped>
abbr {
  max-width: 150px;
  word-break: initial;
}
.color-circle {
  height: 20px;
  width: 20px;
  background-color: #bbb;
  border-radius: 50%;
  display: inline-block;
}
.container {
  padding: 20px;
  margin-top: 0px;
  flex: 1;
  display: flex;
}
.tree-container {
  flex-basis: 20%;
  border: 1.5px solid #e4e7ed;
  margin-right: 10px;
}
.tabs {
  flex-basis: 80%;
  display: flex;
}
</style>